import * as Yup from 'yup';

import { UserRoleEnum } from '@e-socna/data-layer';
import type { UserRoleId } from '@e-socna/data-layer';

type GlobalRole = Readonly<{
  _id: UserRoleId;
  code: UserRoleEnum;
  isGlobal: boolean;
  permissionCodes: readonly string[];
}>;

// Same rules as the back: one global role at least, and a role granting
// permissions goes with the internal one (permissions only apply to internal
// users).
export const buildGlobalRoleIdsSchema = (userRoles: readonly GlobalRole[]) => {
  const internalRole = userRoles.find(
    ({ code }) => code === UserRoleEnum.Internal,
  );
  const permissionGrantingRoleIds = userRoles
    .filter(
      ({ code, isGlobal, permissionCodes }) =>
        isGlobal &&
        code !== UserRoleEnum.Internal &&
        permissionCodes.length > 0,
    )
    .map(({ _id }) => _id);

  return Yup.array()
    .of(Yup.string().required())
    .min(1, 'Un utilisateur a au moins un rôle global')
    .test(
      'permissions-go-with-internal',
      'Un rôle donnant des permissions nécessite le rôle Interne',
      (roleIds = []) =>
        !roleIds.some((id) =>
          permissionGrantingRoleIds.includes(id as UserRoleId),
        ) ||
        (!!internalRole && roleIds.includes(internalRole._id)),
    );
};
